import CartSaleNarrowContainer from './CartSaleNarrowContainer'

export default CartSaleNarrowContainer
